import React, {useContext, useState, useEffect} from "react";
import omniscanLogo from "../images/omniscanlogo.png";
import PageHeader from "./components/PageHeader";
import LeftMenu from "./components/LeftMenu";
import NavigationCard from "./components/NavigationCard";
import {useHistory} from 'react-router-dom';
import db from '../constants/db';
import { store } from "../context/store.js";
import { CHANGE_SELECTED_PROJECT } from "../constants/action-types";

export default function Home(){
	
	
	const globalState = useContext(store);
  const { dispatch } = globalState;
	
	const history = useHistory();
	
	const[projects, setProjects] = useState([]);
	
	useEffect(() => {
		const fetchProjects = async () => {
      const all = await db.projects.toArray();
      setProjects(all);
      console.log(all);
    };

    fetchProjects();
	}, []);
	
	const thisContainer = {
			display:'flex',
			flexDirection:"column",
			width:"100vw",
			height:'100vh'
	};
	
	const blankClick = () => {
		history.push('/project');
	};
	
	const projectContainer = {
		display:'flex',
		width:"calc(100% - 120px)",
		marginTop:"70px",
		marginLeft:"30px",
		overflow:"auto",
		alignSelf:"center",
		flexWrap:"wrap"
	};
	
	const getProject = (id) => {
		return projects.find(project => project.id === id);
	};
	
	const selectProject = (id) => {
		dispatch({ type: CHANGE_SELECTED_PROJECT, value: getProject(id) });
		history.push('/project');
	};
	
	const projectDisplay = projects.map((item, index) => 
		<NavigationCard
				id={item.id}
				title={item.name}
				description={item.description}
				clickFunction={selectProject}
				photo={item.photo}
		/>
	);
	
	return (
		<div style={thisContainer}>
			<PageHeader
				title="My Projects"
			/>
			<LeftMenu/>
			<div style={projectContainer}>
				{projectDisplay}
			</div>
		</div>
	);
}